var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaSolidUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2051_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55 6.125C3.48766 6.125 4.25 5.34023 4.25 4.375C4.25 3.40977 3.48766 2.625 2.55 2.625C1.61234 2.625 0.85 3.40977 0.85 4.375C0.85 5.34023 1.61234 6.125 2.55 6.125ZM14.45 6.125C15.3877 6.125 16.15 5.34023 16.15 4.375C16.15 3.40977 15.3877 2.625 14.45 2.625C13.5123 2.625 12.75 3.40977 12.75 4.375C12.75 5.34023 13.5123 6.125 14.45 6.125ZM15.3 7H13.6C13.1325 7 12.7102 7.19414 12.402 7.50859C13.4725 8.11289 14.2322 9.20391 14.3969 10.5H16.15C16.6202 10.5 17 10.109 17 9.625V8.75C17 7.78477 16.2377 7 15.3 7ZM8.5 7C10.1442 7 11.475 5.63008 11.475 3.9375C11.475 2.24492 10.1442 0.875 8.5 0.875C6.85578 0.875 5.525 2.24492 5.525 3.9375C5.525 5.63008 6.85578 7 8.5 7ZM10.54 7.875H10.3195C9.76703 8.14844 9.15344 8.3125 8.5 8.3125C7.84656 8.3125 7.23563 8.14844 6.68047 7.875H6.46C4.77063 7.875 3.4 9.28594 3.4 11.025V11.8125C3.4 12.5371 3.97109 13.125 4.675 13.125H12.325C13.0289 13.125 13.6 12.5371 13.6 11.8125V11.025C13.6 9.28594 12.2294 7.875 10.54 7.875ZM4.59797 7.50859C4.28984 7.19414 3.8675 7 3.4 7H1.7C0.762344 7 0 7.78477 0 8.75V9.625C0 10.109 0.379844 10.5 0.85 10.5H2.60047C2.76781 9.20391 3.5275 8.11289 4.59797 7.50859Z",
    fill: "#27346A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2051_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaSolidUsers);
export default __webpack_public_path__ + "static/media/fa-solid_users.508c4f3e98cb3ddd7fefcea8c0051eca.svg";
export { ForwardRef as ReactComponent };